module.exports = __webpack_public_path__ + "img/nav-heslb.7192ba1d.svg";